import { useState, useCallback } from 'react';
const Closed = () => ({ images: [], index: 0 });
export const useLightbox = () => {
    const [state, setState] = useState(Closed());
    const open = useCallback((images, startIndex = 0) => {
        setState({ images, index: startIndex });
    }, []);
    const close = useCallback(() => setState(Closed()), []);
    const prev = useCallback(() => {
        setState(s => (Object.assign(Object.assign({}, s), { index: s.index > 0 ? s.index - 1 : s.images.length - 1 })));
    }, []);
    const next = useCallback(() => {
        setState(s => (Object.assign(Object.assign({}, s), { index: s.index < s.images.length - 1 ? s.index + 1 : 0 })));
    }, []);
    return {
        images: state.images,
        index: state.index,
        isOpen: state.images.length > 0,
        open,
        close,
        prev,
        next,
    };
};
